import React from 'react';
import ImportOperations from './ImportOperations';
import http from 'utils/http';

class ImportOperationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // value: this.props.match.params.tab || 'loading_accessories',
      value: 'consignee',
      service: false,
    };
  }

  componentDidMount() {
    http.get('/settings?key=service').then(({ data }) => {
      if (data.data) {
        let Service = data.data?.find((item) => item.key === 'service');
        if (Service) {
          this.setState({ service: Service?.value && Service.value?.data === 'true' ? true : false });
        }
      }
    });
  }


  handleChange = (newValue) => {
    // if (this.props.match.url.includes('loading_acc')) {
    //   this.props.history.replace(`${newValue}`);
    // } else {
    //   this.props.history.replace(`admin/export/${newValue}`);
    // }
    this.setState({ value: newValue });
  };

  render() {
    return (
      <>
        <ImportOperations
          handleChange={this.handleChange}
          value={this.state.value}
          service={this.state.service}
        />
      </>
    );
  }
}

export default ImportOperationContainer;
